// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"ResultList__contentGrid","info":"ResultList__info"};